import { render, staticRenderFns } from "./TradingPortal.vue?vue&type=template&id=bb6622e2&scoped=true&"
import script from "./TradingPortal.vue?vue&type=script&lang=ts&"
export * from "./TradingPortal.vue?vue&type=script&lang=ts&"
import style0 from "./TradingPortal.vue?vue&type=style&index=0&id=bb6622e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6622e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VRow})
